var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
var StockAudit = /** @class */ (function (_super) {
    __extends(StockAudit, _super);
    function StockAudit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StockAudit.prototype.getId = function () {
        return Number(this.id);
    };
    StockAudit.prototype.getLocationName = function () {
        return this.location_name;
    };
    StockAudit.prototype.getProductName = function () {
        return this.product_name;
    };
    StockAudit.prototype.getPendingQuantity = function () {
        return Number(this.pending_quantity);
    };
    StockAudit.prototype.getQuantity = function () {
        return Number(this.quantity);
    };
    StockAudit.prototype.getPDFRecord = function () {
        return {
            id: this.getId(),
            location: this.getLocationName(),
            product: this.getProductName(),
            quantity: this.getQuantity(),
            pendingQuantity: this.getPendingQuantity(),
        };
    };
    return StockAudit;
}(Model));
export default StockAudit;
